/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Eudirectivesintro2Inputs */

const id_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalam mengembangkan Kebijakan Penggunaan Wajar kami, kami telah mempertimbangkan prinsip-prinsip yang diuraikan dalam direktif hak cipta UE berikut:`)
};

const ms_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalam membangunkan Dasar Penggunaan Adil kami, kami telah mengambil kira prinsip yang digariskan dalam arahan hak cipta EU berikut:`)
};

const da_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I udviklingen af vores Fair Use Politik har vi taget hensyn til principperne i følgende EU-ophavsretsdirektiver:`)
};

const de_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei der Entwicklung unserer Fair-Use-Richtlinie haben wir die Grundsätze der folgenden EU-Urheberrechtsrichtlinien berücksichtigt:`)
};

const en_us2_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In developing our Fair Use Policy, we have taken into consideration the principles outlined in the following EU copyright directives:`)
};

const es_es2_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al desarrollar nuestra Política de Uso Justo, hemos tomado en consideración los principios descritos en las siguientes directivas de derechos de autor de la UE:`)
};

const es_mx2_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al desarrollar nuestra Política de Uso Justo, hemos tomado en consideración los principios descritos en las siguientes directivas de derechos de autor de la UE:`)
};

const fil_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sa pag-develop ng aming Patakaran sa Patas na Paggamit, isinasaalang-alang namin ang mga prinsipyong nakabalangkas sa mga sumusunod na EU copyright directive:`)
};

const fr_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En développant notre politique d'utilisation équitable, nous avons pris en considération les principes énoncés dans les directives européennes suivantes :`)
};

const it_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nello sviluppo della nostra Politica di Fair Use, abbiamo preso in considerazione i principi delineati nelle seguenti direttive sul copyright dell'UE:`)
};

const hu_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use irányelvünk kidolgozása során figyelembe vettük a következő EU-s szerzői jogi irányelvekben foglalt elveket:`)
};

const nl_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bij het ontwikkelen van ons Fair Use-beleid hebben we rekening gehouden met de principes in de volgende EU-auteursrechtrichtlijnen:`)
};

const no_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ved utviklingen av våre retningslinjer for rimelig bruk har vi tatt hensyn til prinsippene skissert i følgende EU-opphavsrettsdirektiver:`)
};

const pl_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opracowując naszą Politykę dozwolonego użytku, wzięliśmy pod uwagę zasady określone w następujących unijnych dyrektywach dotyczących praw autorskich:`)
};

const pt_br2_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao desenvolver a nossa Política de Utilização Justa, levámos em consideração os princípios descritos nas seguintes diretivas de direitos de autor da UE:`)
};

const pt_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao desenvolver a nossa Política de Uso Justo, tivemos em consideração os princípios descritos nas seguintes diretivas de direitos de autor da UE:`)
};

const ro_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`În elaborarea Politicii noastre de utilizare corectă, am luat în considerare principiile descrise în următoarele directive UE privind drepturile de autor:`)
};

const fi_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehittäessämme kohtuullisen käytön käytäntöämme olemme ottaneet huomioon seuraavissa EU:n tekijänoikeusdirektiiveissä kuvatut periaatteet:`)
};

const sv_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`När vi utvecklade vår policy för skälig användning har vi tagit hänsyn till principerna i följande EU-upphovsrättsdirektiv:`)
};

const vi_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khi xây dựng Chính sách Sử dụng Hợp lý của mình, chúng tôi đã xem xét các nguyên tắc được nêu trong các chỉ thị bản quyền EU sau:`)
};

const tr_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adil Kullanım Politikamızı geliştirirken, aşağıdaki AB telif hakkı direktiflerinde belirtilen ilkeleri dikkate aldık:`)
};

const cs_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Při vytváření našich Zásad spravedlivého použití jsme vzali v úvahu zásady uvedené v následujících směrnicích EU o autorském právu:`)
};

const bg_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При разработването на нашата Политика за честна употреба взехме предвид принципите, изложени в следните директиви на ЕС за авторското право:`)
};

const ru_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрабатывая нашу Политику добросовестного использования, мы учли принципы, изложенные в следующих директивах Европейского Союза по авторскому праву:`)
};

const uk_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розробляючи нашу Політику добросовісного використання, ми врахували принципи, викладені в наступних директивах ЄС щодо авторського права:`)
};

const ar_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عند تطوير سياسة الاستخدام العادل لدينا، أخذنا في الاعتبار المبادئ الموضحة في توجيهات حقوق الطبع والنشر التالية للاتحاد الأوروبي:`)
};

const hi_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमने EU कॉपीराइट निर्देशों में उल्लिखित सिद्धांतों पर विचार किया है:`)
};

const th_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ในการพัฒนานโยบายการใช้งานโดยชอบของเรา เราได้พิจารณาหลักการที่ระบุไว้ในคำสั่งลิขสิทธิ์ของสหภาพยุโรปดังต่อไปนี้:`)
};

const ja_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フェアユースポリシーの策定にあたり、以下の EU 著作権指令に概説された原則を考慮しました：`)
};

const zh_cn2_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在制定我们的合理使用政策时，我们考虑了以下欧盟版权指令中概述的原则：`)
};

const zh_hant1_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在制定我們的合理使用政策時，我們考慮了以下歐盟版權指令中概述的原則：`)
};

const ko_privacy_eudirectivesintro2 = /** @type {(inputs: Privacy_Eudirectivesintro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공정 사용 정책을 개발하면서 다음 EU 저작권 지침에 명시된 원칙을 고려했습니다:`)
};

/**
* | output |
* | --- |
* | "In developing our Fair Use Policy, we have taken into consideration the principles outlined in the following EU copyright directives:" |
*
* @param {Privacy_Eudirectivesintro2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_eudirectivesintro2 = /** @type {((inputs?: Privacy_Eudirectivesintro2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Eudirectivesintro2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_eudirectivesintro2(inputs)
	if (locale === "ms") return ms_privacy_eudirectivesintro2(inputs)
	if (locale === "da") return da_privacy_eudirectivesintro2(inputs)
	if (locale === "de") return de_privacy_eudirectivesintro2(inputs)
	if (locale === "en-US") return en_us2_privacy_eudirectivesintro2(inputs)
	if (locale === "es-ES") return es_es2_privacy_eudirectivesintro2(inputs)
	if (locale === "es-MX") return es_mx2_privacy_eudirectivesintro2(inputs)
	if (locale === "fil") return fil_privacy_eudirectivesintro2(inputs)
	if (locale === "fr") return fr_privacy_eudirectivesintro2(inputs)
	if (locale === "it") return it_privacy_eudirectivesintro2(inputs)
	if (locale === "hu") return hu_privacy_eudirectivesintro2(inputs)
	if (locale === "nl") return nl_privacy_eudirectivesintro2(inputs)
	if (locale === "no") return no_privacy_eudirectivesintro2(inputs)
	if (locale === "pl") return pl_privacy_eudirectivesintro2(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_eudirectivesintro2(inputs)
	if (locale === "pt") return pt_privacy_eudirectivesintro2(inputs)
	if (locale === "ro") return ro_privacy_eudirectivesintro2(inputs)
	if (locale === "fi") return fi_privacy_eudirectivesintro2(inputs)
	if (locale === "sv") return sv_privacy_eudirectivesintro2(inputs)
	if (locale === "vi") return vi_privacy_eudirectivesintro2(inputs)
	if (locale === "tr") return tr_privacy_eudirectivesintro2(inputs)
	if (locale === "cs") return cs_privacy_eudirectivesintro2(inputs)
	if (locale === "bg") return bg_privacy_eudirectivesintro2(inputs)
	if (locale === "ru") return ru_privacy_eudirectivesintro2(inputs)
	if (locale === "uk") return uk_privacy_eudirectivesintro2(inputs)
	if (locale === "ar") return ar_privacy_eudirectivesintro2(inputs)
	if (locale === "hi") return hi_privacy_eudirectivesintro2(inputs)
	if (locale === "th") return th_privacy_eudirectivesintro2(inputs)
	if (locale === "ja") return ja_privacy_eudirectivesintro2(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_eudirectivesintro2(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_eudirectivesintro2(inputs)
	return ko_privacy_eudirectivesintro2(inputs)
});
export { privacy_eudirectivesintro2 as "privacy.euDirectivesIntro" }